module.exports = __webpack_public_path__ + "static/Phone-security.53fa51e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Phone-security.png
// module id = 40
// module chunks = 168707334958949